// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9061) return "static/chunks/9061-787124f77d6001fb.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5600 ? "05f6971a" : chunkId) + "." + {"674":"9967d9f740ab69b3","5600":"431fdd03f6e7b912","8514":"b199d0b3c602730a"}[chunkId] + ".js";
};